export class ActionPrompt {
	private static instance: ActionPrompt;

	protected actionPrompt = document.getElementById('action-prompt') as HTMLElement;

	public static getInstance(): ActionPrompt {
		if (!ActionPrompt.instance) {
			ActionPrompt.instance = new ActionPrompt();
		}

		return ActionPrompt.instance;
	}

	public showActionPrompt(top: string, left: string): void {
		this.actionPrompt.style.top = top;
		this.actionPrompt.style.left = left;
		this.actionPrompt.style.display = 'block';
	}

	public hideActionPrompt(): void {
		this.actionPrompt.style.display = 'none';
	}
}
